<template>

   <div class="row" id="search-form">
       <div class="col-sm-6 offset-sm-3">
           <h1>{{slogan}}</h1>
           <b-form-input id="input-large" size="lg" type="text" placeholder="Search..." v-model="query" @keyup.native="redirectPage"></b-form-input>
       </div>
   </div>

</template>

<script>
    import Router from '../router';

    export default {
        name: 'SearchForm',
        data () {
          return {
              query: this.$route.params.query
          }
        },
        methods: {
            redirectPage(event) {
                if (event.which === 13) {
                    Router.push({ name: 'Search', params: { query: this.query }})
                }

            }
        },
        computed: {
            slogan: function() {
                if (this.$parent.$parent.$data.site) return this.$parent.$parent.$data.site.slogan;
            }
        }
    }

</script>



// WEBPACK FOOTER //
// src/components/SearchForm.vue